/**
 * Created by wangjunfei on 2021/10/26.
 */

import React from 'react';
import { Button,Spin,message,Modal } from 'antd';
import { Link,withRouter } from 'react-router-dom';
import Table from 'components/Table';
import abortAjaxHoc from 'components/abortAjaxHoc';
import ControlSeparator from 'components/ControlSeparator';
const { confirm } = Modal;
class SDKLivenessList extends React.Component {
    state = {
        loading:false,
        list:[]
    }
    constructor(props){
        super(props);
        this.columns = [
            {
                title: 'Scenes ID',
                dataIndex: 'scene_id',
                key: 'scene_id',
                width: 300
            }, {
                title: 'Scenes Name',
                dataIndex: 'name',
                key: 'name'
            }, {
                title: 'Scenes Describe',
                dataIndex: 'description',
                key: 'description'
            }, {
                title: 'Operate',
                dataIndex: 'state',
                key: 'state',
                render:(state,row)=>{
                    const isSys = state === 'default';
                    return (
                        <ControlSeparator>
                            <a onClick={this.onCopy.bind(this,row.id)}>copy and add</a>
                            {isSys && <Link to={`/pages/verify-scenes/edit/${row.id}`}>check details</Link>}
                            {!isSys && <Link to={`/pages/verify-scenes/edit/${row.id}`}>edit</Link>}
                            {!isSys && <a onClick={this.onOperation.bind(this,row.id,'delete',row)}>delete</a>}
                        </ControlSeparator>
                    );
                }
            }
        ];
    }

    onOperation = (id,type,item)=>{
        let params = {},confirmCont = '';
        if(type === 'setDefault'){
            params = {
                is_default:1
            };
            confirmCont = `Are you sure to set "${item.name}" as the default scene?`;
        }else if(type === 'delete'){
            params = {
                state:'deleted'
            };
            confirmCont = `Are you sure to delete "${item.name}"?`;
        }
        confirm({
            title: confirmCont,
            onOk:()=>{
                this.setState({loading:true});
                return this.props.abortableAjax('POST','/verify_scene/'+id,params).then(()=>{
                    message.success('Successful operation');
                    this.table.refresh();
                }).finally(()=>{
                    this.setState({loading:false});
                });
            }
        });
    }

    onCopy = (id)=>{
        this.setState({loading:true});
        this.props.abortableAjax('POST','/copy_verify_scene',{verify_scene_id:id}).then((res)=>{
            const {id} = res.data;
            this.props.history.push('/pages/verify-scenes/edit/'+id);
        }).catch(()=>{
            this.setState({loading:false});
        });
    };

    onStart = (params)=>{
        const _params = {};
        _params.page_size = params.limit;
        _params.page = params.current;
        if(params.order){
            _params.order_by = params.order;
        }
        if(typeof params.asc !== 'undefined'){
            _params.is_asc = params.asc === 1;
        }
        return this.props.abortableAjax('GET','/verify_scene',_params).then(res=>{
            const data = res.data;
            this.setState({list:data.list,total:data.total});
        });
    }

    render() {
        return (
            <div>
                <Spin spinning={this.state.loading}>
                    <Link to="/pages/verify-scenes/create">
                        <Button type="primary" style={{margin:'10px 0'}}>New Verify Config Scenes</Button>
                    </Link>
                    <Table
                        autoLoad
                        ref={(ref)=>{this.table=ref;}}
                        rowKey = 'id'
                        dataSource={this.state.list}
                        columns={this.columns}
                        onSubmit={this.onStart}
                        total={this.state.total}
                    />
                </Spin>
            </div>
        );
    }
}

export default abortAjaxHoc(withRouter(SDKLivenessList));



// WEBPACK FOOTER //
// ./src/pages/Verify/SDKVerifyList.js